/* eslint-disable no-console */
import { convertBootstrapFilterDropDownList } from './bootstrapConvertFilterDropDownList.js';
import { convertBootstrapProductEmsList } from './bootstrapConvertProductEmsList.js';
import { convertBootstrapSkuOptions } from './bootstrapConvertSkuOptions.js';

export const convertBootstrapData = (bootstrapData) => {
  const newEmsApiFormat = {
    emsDetails: [],
    skuVariantMatrix: {},
    filterDropDown: [],
  };

  // Convert the filterDropdownList to the new format
  if (bootstrapData && Array.isArray(bootstrapData.filterDropdownList) && bootstrapData.filterDropdownList.length > 0) {
    // emsDetails will be added by the individual apps
    newEmsApiFormat.emsDetails = [
      {
        title: 'Version',
      },
    ];
    newEmsApiFormat.skuVariantMatrix = {};
    newEmsApiFormat.filterDropDown = convertBootstrapFilterDropDownList(bootstrapData.filterDropdownList);

    return newEmsApiFormat;
  }

  // Convert Product EMS List to the new format
  if (bootstrapData && bootstrapData.productEmsList) {
    console.log('converting bootstrapData.productEmsList');
    newEmsApiFormat.emsDetails = convertBootstrapProductEmsList(bootstrapData.productEmsList);
  }

  // Convert the skuOptions to the new skuVariantMatrix format
  if (bootstrapData && bootstrapData.skus) {
    console.log('converting bootstrapData.skus', bootstrapData.skus);
    const result = convertBootstrapSkuOptions(bootstrapData.skus);
    console.log('result of convertBootstrapSkuOptions', result);
    // newEmsApiFormat.skuVariantMatrix = convertBootstrapSkuOptions(bootstrapData.skus);
    newEmsApiFormat.skuVariantMatrix = result;
  }

  return newEmsApiFormat;
};
